import React, { useState, useEffect, useCallback } from "react";
import { Row, Col } from "antd";

import UserForm from "../../components/user/userForm";
import { getEntities } from "../../modules/crudOperations";
import UserAddForm from "../../components/user/userAddForm";
import { useUser } from "../../modules/redux/session/useAuth";
import { parseDateTime } from "../../modules/consignmentFunctions";
import UserListTable from "../../components/userList/userListTable";
import UserListHeader from "../../components/userList/userListHeader";
import { roleNames, isUserAdmin, isSuperAdmin } from "../../modules/session";

function UserList() {
  const [userFormRef, setUserFormRef] = useState();
  const saveUserFormRef = useCallback((formRef) => {
    setUserFormRef(formRef);
  }, []);
  const [userAddFormRef, setUserAddFormRef] = useState();
  const saveUserAddFormRef = useCallback((formRef) => {
    setUserAddFormRef(formRef);
  }, []);

  const [user, setUser] = useState();
  const [showNewUser, setShowNewUser] = useState();
  const handleNewUserClick = useCallback(() => {
    setShowNewUser(true);
    userFormRef && userFormRef.resetFields();
  }, [userFormRef]);

  const [showAddUser, setShowAddUser] = useState();
  const handleAddUserClick = useCallback(() => {
    setShowAddUser(true);
    userAddFormRef && userAddFormRef.resetFields();
  }, [userAddFormRef]);

  const [users, setUsers] = useState();
  const loadUsers = useCallback(() => {
    setUser();
    getEntities("user", setUsers, (u) => ({
      key: u.id,
      firstname: u.firstname,
      lastname: u.lastname,
      username: u.username,
      email: u.email,
      blocked: u.blocked,
      userRole: u.userRole,
      lastLogin: parseDateTime(u.lastLogin),
      passwordChange: parseDateTime(u.passwordChange),
      passwordValidity: parseDateTime(u.passwordValidity),
      admin: u.userRole && isUserAdmin(u.userRole.name),
    }));
  }, []);

  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  const loggedUser = useUser();
  const [admin, setAdmin] = useState();
  const [userId, setUserId] = useState();
  const [superAdmin, setSuperAdmin] = useState();
  const [superReader, setSuperReader] = useState();
  const [customerService, setCustomerService] = useState();
  useEffect(() => {
    if (loggedUser) {
      setUserId(loggedUser.id);
      setSuperAdmin(isSuperAdmin(loggedUser.role));
      setSuperReader(loggedUser.role === roleNames.superReader);
      setAdmin(isUserAdmin(loggedUser.role) || isSuperAdmin(loggedUser.role));
      setCustomerService(
        roleNames.customerServiceRoles.includes(loggedUser.role),
      );
    }
  }, [loggedUser]);

  return (
    <Row>
      <Col>
        <UserListHeader
          admin={admin || customerService}
          onNewUserClick={handleNewUserClick}
          onAddUserClick={handleAddUserClick}
        />
        <UserListTable
          users={users}
          admin={admin}
          onSetUser={setUser}
          loadUsers={loadUsers}
          currentUserId={userId}
          superAdmin={superAdmin}
          superReader={superReader}
          customerService={customerService}
          onNewUserClick={handleNewUserClick}
        />
        <UserForm
          user={user}
          onSetUser={setUser}
          ref={saveUserFormRef}
          visible={showNewUser}
          loadUsers={loadUsers}
          setVisible={setShowNewUser}
        />
        <UserAddForm
          visible={showAddUser}
          loadUsers={loadUsers}
          ref={saveUserAddFormRef}
          onSetVisible={setShowAddUser}
        />
      </Col>
    </Row>
  );
}

export default UserList;
